import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  return <section className="bg-[#1f2e10] text-white py-16 px-4 border-t-4 border-[#c4f000]" data-id="element-57">
      <div className="max-w-4xl mx-auto text-center" data-id="element-58">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-6" data-id="element-59">
          Don’t leave your child’s health for tomorrow.
        </h2>
        <p className="text-xl text-gray-300 mb-10" data-id="element-60">
          Start prepping nutritious, delicious, and FAST lunches today.
        </p>

        <div className="mb-12" data-id="element-61">
          <CTAButton href="#offer" className="text-xl py-5 px-10" data-id="element-62">
            GET INSTANT ACCESS NOW!
          </CTAButton>
        </div>

        <div className="text-xs text-gray-500 border-t border-white/10 pt-8 max-w-2xl mx-auto" data-id="element-63">
          <p className="mb-2" data-id="element-64">
            © 2024 Happy Lunchbox System. All rights reserved.
          </p>
          <p data-id="element-65">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </section>;
}